import { ContrastType } from '../types/analysisTypes';

export const getContrastThresholdFromType = (x: ContrastType) => {
  switch (x) {
    case 'STATIC_FROM_CALIB':
    case 'STATIC_FROM_MMI':
      return 3.5;
    default:
      throw new Error(`unrecognised contrast type: ${x}`);
  }
};
